





































































import VueOptions from '@utils/VueOptions'
import FormField from '@ui/FormBuilder/FormField'

settings =
  name: 'FormFieldPhysicalSigns'

  vue:
    props: ['value', 'errors']

    components: {
      FormField,
    }

    data: ->
      signage: @normalizeSignage(@value)

    computed:
      isSignageEnabled: -> @signage.enabled
      isSheetEnabled: -> @isSignageEnabled and @signage.sheet.enabled
      isPopupBannerEnabled: -> @isSignageEnabled and @signage.popup_banner.enabled

    methods:
      normalizeSignage: (signage) ->
        signage = JSON.parse(JSON.stringify(signage || {}))

        signage ||= {}
        signage.enabled ||= null unless signage.enabled?
        signage.sheet ||= {}
        signage.sheet.enabled = signage.enabled unless signage.sheet.enabled?
        signage.sheet.placement ||= null
        signage.sheet.reach ||= undefined
        signage.sheet.can_print ||= false
        signage.popup_banner ||= {}
        signage.popup_banner.enabled = signage.enabled unless signage.popup_banner.enabled?
        signage.popup_banner.placement ||= null
        signage.popup_banner.reach ||= undefined

        @signage = signage

      hiInputChange: ->
        @inputChanged()

      hiGroupChanged: ->
        signage = { enabled: @signage.enabled }
        @normalizeSignage signage
        @inputChanged()

      hiSubgroupChanged: (subgroupKey) ->
        signage = { ...@signage }
        signage[subgroupKey] = { enabled: false } unless signage[subgroupKey].enabled
        @normalizeSignage signage
        @inputChanged()

      inputChanged: ->
        @$emit 'input', @signage
        @$emit 'change', @signage

    watch:
      value: (value) ->
        @normalizeSignage value

export default VueOptions.vue settings
